var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6508 10.4558C29.1955 9.72879 28.3898 9.29431 27.4957 9.29431H25.2639V5.24731C25.2639 4.27061 24.4301 3.47581 23.4059 3.47581H12.4816C12.4658 3.47581 12.4547 3.47117 12.4506 3.46828L10.4953 0.764678C10.1484 0.286175 9.57715 0 8.96602 0H1.85801C0.833203 0 0 0.794801 0 1.7715V21.1868C0 22.1867 0.853711 23 1.90313 23H24.0141C24.3586 23 24.6563 22.8036 24.7998 22.518H24.8004L29.7551 12.6792C30.1154 11.966 30.0756 11.1348 29.6508 10.4558ZM1.85801 1.7379H8.96543C9.01816 1.7379 9.05391 1.7605 9.06504 1.77614L11.0232 4.48321C11.3537 4.94086 11.8992 5.21371 12.4816 5.21371H23.4059C23.4674 5.21371 23.4984 5.2421 23.5061 5.25252V9.29431H7.59961C6.61289 9.29431 5.71582 9.84407 5.31387 10.6951L1.75781 18.2184V1.77672C1.76543 1.76629 1.79648 1.7379 1.85801 1.7379ZM28.1824 11.9046L23.4703 21.2615H2.25996L6.90645 11.4308C7.01895 11.1927 7.29785 11.0322 7.59961 11.0322H27.4957C27.7764 11.0322 28.0236 11.1585 28.1561 11.3705C28.2305 11.4899 28.2955 11.6793 28.1824 11.9046Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFolder);
export default __webpack_public_path__ + "static/media/mobile-folder.5fe74149.svg";
export { ForwardRef as ReactComponent };